import { Checkbox } from '@mantine/core';
import { t } from 'i18next';

interface AllPluginsCheckboxProps {
  plugins: { enabled: boolean }[];
  /** Called with the state every plugin should get. */
  onChange: (enabled: boolean) => void;
}

/**
 * Turns every plugin on or off at once. Shows a dash when only some are on;
 * clicking then turns them all on.
 */
export const AllPluginsCheckbox = ({
  plugins,
  onChange,
}: AllPluginsCheckboxProps) => {
  const enabled = plugins.filter((p) => p.enabled).length;
  const all = plugins.length > 0 && enabled === plugins.length;

  return (
    <Checkbox
      label={t('plugins.all')}
      checked={all}
      indeterminate={enabled > 0 && !all}
      onChange={() => onChange(!all)}
      mb="xs"
    />
  );
};
